import { apiClient } from './client';

/**
 * NOTIF-07 (VEK-168) — tell the server which language this user reads the web app in, so a notification rendered
 * off the request thread (Web Push, the staff Telegram bot) follows the UI, not the Telegram app or a server default.
 *
 * Called on every full sign-in (`JWTContext.handleFullAuth`) and on every header language switch
 * (`i18n/index.ts`). Fire-and-forget: a signed-out switch sends nothing, and a failed or 404'd PUT (an older API)
 * is swallowed — the preference is a convenience, never a blocker. Spec: `openspec/specs/user-management/spec.md`
 * § A user records the web language notifications should use.
 */
export function syncPreferredLanguage(language: string | undefined | null): void {
  const code = (language ?? '').split('-')[0].toLowerCase();
  if ((code !== 'en' && code !== 'uk') || !apiClient.getToken()) return;
  void apiClient.put<void>('/users/me/language', { language: code }).catch(() => {
    // deliberately silent — see the header comment
  });
}
